module.exports = __webpack_public_path__ + "img/Brondby.ba78e189.png";